var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoolean = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.54 6h12.92c.806 0 1.58.316 2.15.879S21.5 8.204 21.5 9v6a2.98 2.98 0 0 1-.89 2.121 3.06 3.06 0 0 1-2.15.879H5.54a3.06 3.06 0 0 1-2.15-.879A2.98 2.98 0 0 1 2.5 15V9c0-.796.32-1.559.89-2.121A3.06 3.06 0 0 1 5.54 6m8.36 2.625h-3.42a3.44 3.44 0 0 0-2.372 1.013A3.35 3.35 0 0 0 7.13 12c0 .883.35 1.73.977 2.362.626.63 1.477.994 2.372 1.013h3.42a3.44 3.44 0 0 0 2.372-1.013c.626-.631.977-1.479.977-2.362s-.35-1.73-.977-2.362A3.44 3.44 0 0 0 13.9 8.625m0 5.625c-1.262 0-2.28-1.007-2.28-2.25 0-1.245 1.02-2.25 2.28-2.25 1.262 0 2.28 1.007 2.28 2.25 0 1.245-1.02 2.25-2.28 2.25",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoolean);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boolean.567d0b3e.svg";